import { Box, Button, Typography } from "@mui/material";
import { headerStyle } from "../../../../../EConsent/Builder/block.style";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../../Redux/hooks";
import { errorToastMessage, toastMessage } from "../../../../../../utils/toast";
import { AxiosResponse } from "axios";
import http from "../../../../../../utils/http";
import { setConsentLoader } from "../../../../../../Redux/reducers/providerConsentSlice";
import BackButton from "../../../../../Common/UI/BackButton";

const ConsentFormHeader: React.FC = () => {
  const consentName = useAppSelector(
    (state) => state.providerConsent.consentName
  );
  const participantId = useAppSelector(
    (state) => state.providerConsent.participantId
  );
  const studyId = useAppSelector((state) => state.providerConsent.studyId);
  const formId = useAppSelector((state) => state.providerConsent.formId);
  const versionId = useAppSelector((state) => state.providerConsent.versionId);
  const type = useAppSelector((state) => state.providerConsent.type);
  const blocks = useAppSelector((state) => state.providerConsent.blocks);
  const formType = useAppSelector((state) => state.providerConsent.formType);
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
    const type = formType === "sunshine" ? "sunshine_forms" : "consent";
    sessionStorage.setItem("menu-type", type);
  };

  const handleFinalize = async () => {
    try {
      for (let i = 0; i < blocks.length; i++) {
        const block = blocks[i];

        if (!block.editable) continue;

        const blockResponse = block.response;
        const position = block.position;

        if (block.config.name && !blockResponse?.firstName) {
          toastMessage(
            "warning",
            `First Name cannot be empty (Block Position: ${position})`
          );
          return;
        }

        if (block.config.name && !blockResponse?.lastName) {
          toastMessage(
            "warning",
            `Last Name cannot be empty (Block Position: ${position})`
          );
          return;
        }

        if (block.config.address && !blockResponse?.address) {
          toastMessage(
            "warning",
            `Address cannot be empty (Block Position: ${position})`
          );
          return;
        }

        if (block.config.date && !blockResponse?.date) {
          toastMessage(
            "warning",
            `Date cannot be empty (Block Position: ${position})`
          );
          return;
        }

        if (!blockResponse?.signature) {
          toastMessage(
            "warning",
            `Signature cannot be empty (Block Position: ${position})`
          );
          return;
        }
      }

      dispatch(setConsentLoader(true));
      const prefix =
        type === "platform" ? `/platform/admin/` : `/admin/study/${studyId}/`;

      const res: AxiosResponse = await http.post(
        `${prefix}${
          formType === "sunshine" ? "sunshine" : "econsent"
        }/participants/${participantId}/${formId}/versions/${versionId}/finalize`
      );

      toastMessage("success", res.data.message);
      handleBack();
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      dispatch(setConsentLoader(false));
    }
  };

  return (
    <Box sx={headerStyle}>
      <BackButton onClick={handleBack} sx={{ mr: 1 }} />
      <Typography
        variant="h2"
        color="text.primary"
        sx={{
          flex: 1,
          minWidth: "0px",
        }}
        noWrap
      >
        {consentName || "Consent Form"}
      </Typography>
      <span style={{ marginLeft: "auto" }}></span>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="contained" onClick={handleFinalize}>
          Finalize
        </Button>
      </Box>
    </Box>
  );
};

export default ConsentFormHeader;
